<admin-app-header></admin-app-header>

<div class="container-fluid">
    <div class="row header mb-4">
        <div class="col-auto p-0">
            <h2 class="mb-0">Create Campaign</h2>
        </div>
    </div>

    <div class="row" *ngIf="loading">
        <div class="col-12 text-center p-5">
            <i class="fas fa-spinner fa-spin fa-3x"></i>
            <p class="mt-3">Saving campaign...</p>
        </div>
    </div>

    <div class="row" *ngIf="!loading">
        <div class="col-md-8">
            <div class="card">
                <div class="card-body">
                    <form [formGroup]="campaignForm" (ngSubmit)="save()">
                        <div class="mb-3">
                            <label for="campaignName" class="form-label">Campaign Name (Tracking ID) <span class="text-danger">*</span></label>
                            <input
                                type="text"
                                class="form-control"
                                id="campaignName"
                                formControlName="campaignName"
                                placeholder="e.g., fb-summer24 or linkedin-promo"
                                maxlength="20"
                                [class.is-invalid]="campaignForm.get('campaignName')?.invalid && campaignForm.get('campaignName')?.touched"
                            />
                            <div class="form-text">Unique tracking ID: max 20 characters. Spaces and underscores auto-convert to dashes.</div>
                            <div class="invalid-feedback" *ngIf="campaignForm.get('campaignName')?.hasError('required')">Campaign name is required</div>
                            <div class="invalid-feedback" *ngIf="campaignForm.get('campaignName')?.hasError('maxlength')">Campaign name must be 20 characters or less</div>
                            <div class="invalid-feedback" *ngIf="campaignForm.get('campaignName')?.hasError('pattern')">Only letters, numbers, and dashes allowed</div>
                        </div>

                        <div class="mb-3">
                            <label for="description" class="form-label">Description</label>
                            <textarea
                                class="form-control"
                                id="description"
                                formControlName="description"
                                rows="3"
                                placeholder="e.g., Summer 2024 Facebook Ads - Targeting young professionals..."
                            ></textarea>
                            <div class="form-text">Optional description for the campaign's purpose, audience, etc.</div>
                        </div>

                        <div class="mb-3">
                            <label for="source" class="form-label">Source <span class="text-danger">*</span></label>
                            <select class="form-select" id="source" formControlName="source">
                                <option value="">Select a source...</option>
                                <option *ngFor="let source of campaignSources" [value]="source">{{ source }}</option>
                            </select>
                            <div class="form-text">Where is this traffic coming from?</div>
                        </div>

                        <div class="mb-3">
                            <label for="landingPageUrl" class="form-label">Landing Page URL <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" id="landingPageUrl" formControlName="landingPageUrl" placeholder="https://parkupp.com/" />
                            <div class="form-text">The page users will land on when clicking the campaign link</div>
                        </div>

                        <div class="mb-3">
                            <label for="leadUser" class="form-label">Lead User (Optional)</label>
                            <select class="form-select" id="leadUser" formControlName="leadUser">
                                <option value="">None</option>
                                <option *ngFor="let assignee of crmAssignees" [value]="assignee.$key">{{ assignee.displayName }}</option>
                            </select>
                            <div class="form-text">Automatically assign leads from this campaign to a specific user</div>
                        </div>

                        <div class="d-flex gap-2">
                            <button type="submit" class="btn btn-primary" [disabled]="campaignForm.invalid || loading"><i class="fas fa-save me-2"></i>Create Campaign</button>
                            <button type="button" class="btn btn-secondary" (click)="cancel()"><i class="fas fa-times me-2"></i>Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="col-md-4">
            <div class="card">
                <div class="card-header">
                    <h5 class="mb-0">Campaign Preview</h5>
                </div>
                <div class="card-body">
                    <div *ngIf="generatedUrl" class="text-center">
                        <qrcode [qrdata]="generatedUrl" [width]="250" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
                        <div class="mt-3">
                            <h6>Generated URL:</h6>
                            <p class="small text-muted text-break">{{ generatedUrl }}</p>
                            <button type="button" class="btn btn-sm btn-outline-primary" (click)="copyGeneratedUrl()"><i class="fas fa-copy me-1"></i>Copy URL</button>
                        </div>
                    </div>
                    <div *ngIf="!generatedUrl" class="text-center text-muted">
                        <i class="fas fa-qrcode fa-3x mb-3"></i>
                        <p>Fill in the form to generate your campaign link and QR code</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
